<template lang='pug'>
  aside.main-sidebar(v-if="isConnected", ref='mainSidebar', @scroll="placeLiSpan")
    section.sidebar
      ul.sidebar-menu(@click='onActivityClick', @mousemove='placeLiSpan')
        li
          router-link(:to='{name: "ImproveYourExperience"}')
            .relative.inline
              i.fa.fa-lightbulb-o.light(:class='{animateLight: nbImprovements}')
            span {{$t("sidemenu.improveYourExperience")}}
        li
          router-link(:to='{name: "News", params: defaultRouteParams}')
            .relative.inline
              i.fa.fa-bell-o(:class='{animateRing: hasNews}')
            span {{$t("sidemenu.news")}}
        //- li(v-if='nbToAnswer > 0')
        //-   router-link(:to='{ name: "FastAnswers", params: defaultRouteParams}')
        //-     .relative.inline
        //-       i.fa.fa-check-circle
        //-       .badge.info {{nbToAnswer}}
        //-     span {{$t("sidemenu.toAnswer")}}
        li
          router-link(:to='{ name: "Events", params: defaultRouteParams}', @click.native="eventsBus.$emit(eventsBus.CLICK_ON_SIDEBAR)")
            .relative.inline
              i.fa.fa-calendar
              //- .badge.success 2
            span {{$t("sidemenu.events")}}
        li
          router-link(:to='{ name: "Conversations", params: defaultRouteParams}', @click.native="eventsBus.$emit(eventsBus.CLICK_ON_SIDEBAR)")
            .relative.inline
              i.fa.fa-envelope-o
              .badge.info(v-if="conversationsUpdateCount > 0") {{conversationsUpdateCount}}
            span {{$t("sidemenu.messages")}}
        li
          router-link(to='/nodes')
            .relative.inline
              i.fa.fa-files-o
              //- .badge.danger !
            span {{$t("sidemenu.files")}}
        li
          router-link(:to='{ name: "Polls", params: defaultRouteParams}')
            i.fa.fa-tasks
            span {{$t("sidemenu.polls")}}
        li
          router-link(:to='{ name: "Members", params: defaultRouteParams}', @click.native="eventsBus.$emit(eventsBus.CLICK_ON_SIDEBAR)")
            .relative.inline
              i.fa.fa-users
            span(v-if='!isAllGroopsSelected') {{$t("sidemenu.members")}}
            span(v-else) {{$t("sidemenu.contacts")}}
        li(v-if='!isAllGroopsSelected && !isPersonalGroopSelected')
          router-link(:to='{ name: "GroupManagement", params: defaultRouteParams}')
            .relative.inline
              i.fa.fa-cog
            span {{$t("sidemenu.groupManagement")}}
        li
          router-link(:to='{ name: "GroupPage", params: defaultRouteParams}')
            i.fa.fa-globe
            span {{$t("sidemenu.groupPages")}}
        li(v-if='user && user.isAdmin')
          router-link(:to='{ name: "Administration"}')
            i.fa.fa-cogs
            span {{$t("sidemenu.administration")}}
        template(v-if="invitations.length > 0 || invitationsToAccept.length > 0")
          hr
          li
            router-link(:to='{name: "Invitations", params: defaultRouteParams}')
              .relative.inline
                i.fa.fa-user-plus
                .badge.success(v-if='(pendingInvitations.length + pendingInvitationsToAccept.length) > 0') {{pendingInvitations.length + pendingInvitationsToAccept.length}}
              span {{$t("sidemenu.invitations")}}
        hr
        li
          router-link(:to='{ name: "Chat", params: defaultRouteParams}', :class='{loading: chatStatus == STATUS.LOADING}')
            i.fa.fa-comments-o
            span {{$t("sidemenu.chat")}}
        li(v-for='contact in listOfUsers')
          a.chatUser(@click="openChatConversation(contact)", :class=`{
              active: isQuickChat([contact]), 
              new: chatDataFor([user, contact]) && chatDataFor([user, contact]).status == STATUS.NEW,
              online: userIsOnline(contact)
            }`)
            vue-object-img(:object='contact')
            span {{$t("sidemenu.discussWith")}} {{contact.name}}

</template>

<script>
import {mapGetters} from 'vuex'
import VueObjectImg from '@/components/shared/VueObjectImg'
import modalsBus from '@/components/shared/ModalsBus'
import eventsBus from '@/components/shared/EventsBus'

import _ from 'lodash'

import STATUS from '@/utils/status'

export default {
  data () {
    return {
      eventsBus,
      STATUS
    }
  },
  components: {
    VueObjectImg
  },
  computed: {
    ...mapGetters('user', [
      'isConnected',
      'user'
    ]),
    ...mapGetters('conversations', [
      'conversationsUpdateCount'
    ]),
    ...mapGetters('chat', [
      'onlineContacts',
      'listOfUsers',
      'quickConversationUsers',
      'chatDataFor',
      'userIsOnline'
    ]),
    ...mapGetters('groops', [
      'isPersonalGroopSelected',
      'firstSelectedGroop',
      'selectedGroopsId',
      'isAllGroopsSelected',
      'invitations',
      'invitationsToAccept',
      'pendingInvitations',
      'pendingInvitationsToAccept'
    ]),
    ...mapGetters('groops', [
      'groops',
      'allTypes'
    ]),
    nbImprovements () {
      let nbImprovements = this.allTypes.reduce((result, type) => {
        return this.groops.filter((g) => g.type === type).length === 0 ? result + 1 : result
      }, 0)
      if (this.groops.length === 0) {
        nbImprovements++
      }
      return nbImprovements
    },
    ...mapGetters('news', [
      'hasNewFor'
    ]),
    defaultRouteParams () {
      return {
        groupId: this.firstSelectedGroop ? this.firstSelectedGroop.id : null
      }
    },
    hasNews () {
      return this.hasNewFor(this.selectedGroopsId)
    },
    nbToAnswer () {
      return this.$store.state.toAnswer.count
    },
    chatStatus () {
      return this.$store.getters['chat/generalStatus']
    }
  },
  methods: {
    onActivityClick () {},
    isQuickChat (contacts) {
      if (this.quickConversationUsers == null) {
        return false
      }
      return _.differenceBy(this.quickConversationUsers, contacts, 'id').length === 0
    },
    placeLiSpan ($event) {
      let li = $event.target.closest('.sidebar li') || this.$refs.mainSidebar.querySelectorAll('li:hover')[0]
      if (!li) {
        return
      }
      let span = li.querySelectorAll('a span')[0]
      if (!span) {
        return
      }
      span.style.marginTop = (0 - 12 - this.$refs.mainSidebar.scrollTop) + 'px'
    },
    openChatConversation (contact) {
      modalsBus.open(modalsBus.modals.CHAT_WITH, [contact])
    }
  }
}
</script>
<style lang="sass">
.main-sidebar .sidebar
  hr
    margin: 10px
    border-top: 1px solid rgba(255,255,255,0.2)
  .sidebar-menu > li > a.loading > i
    animation: loading 1s ease-in-out infinite

  .sidebar-menu > li > a.chatUser
    opacity: 0.5
    padding: 10px 10px 10px 12px
    &:hover, &.active
      opacity: 1
    $size: 23px
    .profileImage
      margin: 0
      height: $size
      line-height: $size
      width: $size
    span
      margin-left: 12px 
      margin-top: -10px
    &.online
      &:after
        content: ' '
        position: absolute
        right: 10px
        top: 25px
        $size: 8px
        width: $size
        height: $size
        border-radius: 50%
        background-color: lighten(green, 10%)
    &.new
      opacity: 1
      .profileImage
        animation: bounceLeft 1.5s 0.5s ease-in infinite
      &:after
        content: ' '
        position: absolute
        right: 10px
        top: 25px
        $size: 8px
        width: $size
        height: $size
        border-radius: 50%
        background-color: lighten(green, 10%)
        animation: loading 1s ease-in-out infinite

  .animateRing
    animation: ring 5s 1s ease-in-out infinite
    transform-origin: 7px 0px 
    color: #FFF
    transition: text-shadow 1s ease
    text-shadow: 0px 8px 10px rgb(249, 255, 22)
    @media(max-width: 467px)
      text-shadow: 0px 2px 20px rgb(249, 255, 22)
      transform-origin: 14px 0px 
  .light
    padding-left: 3px

  .animateLight
    color: #FFF
    transition: text-shadow 1s ease
    text-shadow: 0px 8px 10px rgb(249, 255, 22)
    @media(max-width: 467px)
      text-shadow: 0px 2px 20px rgb(249, 255, 22)
      transform-origin: 14px 0px 

@keyframes loading
    0% 
      opacity: 0.5
    50%
      opacity: 1
    100%
      opacity: 0.5

@keyframes bounceLeft
  0%,
  20%,
  50%,
  80%,
  100%
    transform: translateX(0)
  40%
    transform: translateX(10px)
  60%
    transform: translateX(5px)
</style>



// WEBPACK FOOTER //
// SidebarMenu.vue?6bdcd5fa